import React, { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SummaryDownloadButton from "./PDFDownloader";
import { getHeaderClass } from "../../../utils/agGridHelpers";

const SummaryPage = ({ data, type }) => {
  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  if (!type || !data) {
    return null;
  }
  let summaryRecord = [];
  if (type === "BookwiseOverall" && !Array.isArray(data)) {
    const { report, grandTotal } = data;
    summaryRecord = report.map((item) => ({
      bookNo: item.bookNo,
      totalAmount: item.total,
    }));
    summaryRecord.push({
      rowType: "grandTotal",
      bookNo: "Grand Total",
      totalAmount: grandTotal,
    });
  }

  if (type === "BookwiseYearly" && !Array.isArray(data)) {
    const { summary, OverallTotal } = data;
    const report = summary.map((item) => ({
      year: item.year,
      grandTotal: item.grandTotal,
      books: item.books,
    }));
  

    summaryRecord = report.flatMap((item) => {
      const bookRows = item.books.map((book, index) => ({
        year: item.year,
        bookNo: book.bookNo,
        totalAmount: book.totalAmount,
      }));

      const totalRow = {
        year: item.year,
        bookNo: "Year Total",
        totalAmount: item.grandTotal,
        rowType: "yearTotal",
      };

      return [...bookRows, totalRow];
    });

    const totalOfAllYears = report.reduce(
      (sum, yearData) => sum + yearData.grandTotal,
      0
    );

    summaryRecord.push({
      bookNo: "Grand Total",
      totalAmount: OverallTotal,
      rowType: "grandTotal",
    });
  }

  const columnDefs = [
    {
      headerName: "S.NO",
      valueGetter: (params) =>
        params.data?.rowType === "grandTotal" ? "" : params.node.rowIndex + 1,
    },
    {
      field: "bookNo",
      headerName: "Book No",
      flex:1,
      filter: "agTextColumnFilter",
      valueFormatter: (params) =>
        params.data?.rowType === "grandTotal"
          ? params.value
          : params.value,
    },
    {
      field: "totalAmount",
      headerName: "Amount",
      flex:1,
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
    },
  ];

  const columnDefsYearlyBookwise = [
    {
      headerName: "S.NO",
      valueGetter: (params) => {
        const api = params.api;
        let serial = 0;
        let rowSerial = 0;
        api.forEachNodeAfterFilterAndSort((node) => {
          if (!node.data?.rowType) {
            serial++;
          }
          if (node === params.node) {
            if (!node.data?.rowType) {
              rowSerial = serial;
            } else {
              rowSerial = ""; // Special rows get empty serial
            }
            return;
          }
        });
        return rowSerial;
      },
      flex:1,
    },
    {
      field: "year",
      headerName: "Year",
      flex:1,
      filter: "agTextColumnFilter",
      valueFormatter: (params) =>
        params.data?.rowType === "grandTotal " ||
        params.data?.rowType === "yearTotal"
          ? " "
          : params.value,
    },
    { field: "bookNo", headerName: "BookNo", flex:1, filter: "agTextColumnFilter",},
    {
      field: "totalAmount",
      headerName: "Amount",
      flex:1,
      filter: "agTextColumnFilter",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return new Intl.NumberFormat("en-IN").format(params.value);
      },
    },
  ];
  const getRowStyle = (params) => {
    if (params.data.rowType === "grandTotal") {
      return { fontWeight: "bold", backgroundColor: "#d0ffd0" };
    } else if (params.data.rowType === "subtotal") {
      return { fontWeight: "bold", backgroundColor: "#d0d0ff" };
    } else if (params.data?.rowType === "yearTotal") {
      return { fontWeight: "bold", backgroundColor: "#e6f0ff" };
    }
    return null;
  };
  const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 100,
    headerClass: getHeaderClass,
  };

  return (
    <>
      <div className="ag-theme-alpine" style={{ height: "550px", width: "140vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "10px",
          }}
        >
          <SummaryDownloadButton data={data} type={type} />
        </div>
        <AgGridReact
          ref={gridRef}
          onGridReady={onGridReady}
          rowData={summaryRecord}
          columnDefs={
            (type === "BookwiseOverall"  && columnDefs) ||
            (type === "BookwiseYearly" && columnDefsYearlyBookwise)
          }
          defaultColDef={defaultColDef}
          getRowStyle={getRowStyle}
          domLayout="autoHeight"
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50]}
        />
      </div>
    </>
  );
};

export default SummaryPage;
